import React, { useEffect } from "react";
import { TextChoiceAnswerFormat, TextChoiceDefinition } from "../../../../types/Survey";
import TextChoiceList from "../../Components/TextChoiceList/TextChoiceList";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let answerFormat = props.answerFormat as TextChoiceAnswerFormat;
    let currentResult = props.result as QuestionResultModel;

    return <SurveyFormItem
        label={props.label}
        labelPosition="top"
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <TextChoiceList
            variant={props.variant}
            textChoices={answerFormat.textChoices}
            style={answerFormat.style}
            selectedChoices={currentResult.Choices ? currentResult.Choices as string[] : []}
            onChangeChoices={(choices) => props.onResultChange({ ...props.result, Choices: choices } as QuestionResultModel)}
            descriptionStyle={answerFormat.descriptionStyle} />
    </SurveyFormItem>;
}